module.exports = __webpack_public_path__ + "img/Porsche_wordmark_black_rgb.32936a69.svg";